import { useMemo } from 'react';
import useTrainingSets from '../../hooks/useTrainingSets';
import useGetAllVendors from '../../hooks/vendors/useGetAllVendors';
import { IRulesetSchemaChoiceSource, IRulesetSchemaFieldChoice } from '../../../types/ruleset-types';

interface UseRulesetResourceChoicesArgs {
  source?: IRulesetSchemaChoiceSource;
  dataPoolId: string;
  enabled?: boolean;
  search?: string;
}

export function useRulesetResourceChoices({
  source,
  dataPoolId,
  enabled = true,
  search,
}: UseRulesetResourceChoicesArgs): IRulesetSchemaFieldChoice[] {
  const sourceName = source?.name;
  const normalizedSearch = search?.trim().toLowerCase() || '';

  const trainingSets = useTrainingSets(
    enabled && sourceName === 'training_sets',
    true,
    search || undefined,
    undefined,
    dataPoolId
  );

  const vendors = useGetAllVendors(enabled && sourceName === 'vendors');

  return useMemo(() => {
    if (!enabled || !sourceName) {
      return [];
    }

    if (sourceName === 'training_sets') {
      return trainingSets.map((trainingSet) => ({
        value: trainingSet.id,
        label: trainingSet.label,
      }));
    }

    if (sourceName === 'vendors') {
      return vendors.data
        .filter((vendor) => {
          if (!normalizedSearch) {
            return true;
          }
          return vendor.name.toLowerCase().includes(normalizedSearch);
        })
        .map((vendor) => ({
          value: vendor.id,
          label: vendor.name,
        }));
    }

    return [];
  }, [enabled, normalizedSearch, sourceName, trainingSets, vendors.data]);
}
